<template>
  <div>
    <Header></Header>
    <div class="wrapper" style=" -webkit-overflow-scrolling : touch;">
      <div class="part1">
        <p class="title text-left"></p>
        <p class="subtitle text-left">诚信&nbsp;&nbsp;&nbsp;&nbsp;团队&nbsp;&nbsp;&nbsp;&nbsp;创新&nbsp;&nbsp;&nbsp;&nbsp;激情</p>
      </div>
      <div class="part2">
        <p class="title">及时雨小额贷款</p>
        <p class="cont">上海嘉定及时雨小额贷款股份有限公司于2013年3月成立，经上海市政府批准设立，注册资本金2亿元。</p>
        <p class="cont">公司拥有一支深耕小微金融近20年的核心团队，坚持小而分散的信贷理念，通过数字化打造小微金融的全流程智能风控系统“慧石系统”，服务于机构及小微企业客户。</p>
        <a href="/#/about-us">
          <p class="look-more">更多</p>
        </a>
        <div class="row info">
          <div class="col-6 info-block">
            <p>
              <span class="num">87.53</span>
              <span class="unit">亿</span>
            </p>
            <p class="desc">累计放贷金额</p>
          </div>
          <div class="col-6 info-block">
            <p>
              <span class="num">11095</span>
            </p>
            <p class="desc">累计放贷客户</p>
          </div>
          <div class="col-6 info-block">
            <p>
              <span class="num">30290</span>
            </p>
            <p class="desc">累计放贷笔数</p>
          </div>
          <div class="col-6 info-block">
            <p>
              <span class="num">8</span>
              <span class="num-desc">年</span>
            </p>
            <p class="desc">运营时间</p>
          </div>
        </div>
      </div>
      <div class="part3">
        <p class="title">我们的服务</p>
        <div class="service-block">
          <p class="subtitle">过桥资金</p>
          <p class="desc">客户需要归还银行贷款的本金时，可在我司借款，用于结清现有银行的按揭贷款、抵押贷款等</p>
        </div>
        <div class="service-block">
          <p class="subtitle">小微企业贷</p>
          <p class="desc">为小微企业提供信用贷款，解决融资难、费用贵问题</p>
        </div>
      </div>
      <div class="part4">
        <p class="title">我们的优势</p>
        <div class="row">
          <div class="col-5 text-right left-block">
            <img src="../img/index/icon-1.png" alt />
          </div>
          <div class="col-6 text-left right-block">
            <p class="subtitle">高</p>
            <p class="desc">贷款额度高</p>
            <p class="desc">最高可借500万</p>
          </div>
        </div>
        <div class="row">
          <div class="col-5 text-right left-block">
            <img src="../img/index/icon-2.png" alt />
          </div>
          <div class="col-6 text-left right-block">
            <p class="subtitle">快</p>
            <p class="desc">在线审批</p>
            <p class="desc">2-3天放款</p>
          </div>
        </div>
        <div class="row">
          <div class="col-5 text-right left-block">
            <img src="../img/index/icon-3.png" alt />
          </div>
          <div class="col-6 text-left right-block">
            <p class="subtitle">灵</p>
            <p class="desc">借款期限灵活</p>
            <p class="desc">1-12期任选</p>
          </div>
        </div>
        <div class="row">
          <div class="col-5 text-right left-block">
            <img src="../img/index/icon-4.png" alt />
          </div>
          <div class="col-6 text-left right-block">
            <p class="subtitle">易</p>
            <p class="desc">免抵押</p>
            <p class="desc">免担保</p>
          </div>
        </div>
      </div>
      <div class="part5 text-left">
        <div class="tach-content">
          <p class="title">我们的故事</p>
          <p class="subtitle">一起聆听来自客户的心声</p>
          <p class="green-block"></p>
        </div>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide slide-1">
              <a href="/#/CustomerDetail?id=3">
                <div class="each-block">
                  <p class="intro">老梁，河北赵县农民，今年49岁，2005年响应政改，摇身一变赵县梨业佼佼者，种梨13年“鸭梨山大”！</p>
                </div>
              </a>
            </div>
            <div class="swiper-slide slide-2">
              <a href="/#/CustomerDetail?id=1">
                <div class="each-block">
                  <p class="intro">王颖是土生土长的上海人，从酒店贸易行业转型房车露营，追寻吉普赛人的浪漫情节！</p>
                </div>
              </a>
            </div>
            <div class="swiper-slide slide-3">
              <a href="/#/CustomerDetail?id=2">
                <div class="each-block">
                  <p class="intro">因为是设计师出身，大家都叫他“李工”，浙江人，80后，主要做家具设计、空间规划。</p>
                </div>
              </a>
            </div>
            <div class="swiper-slide slide-4">
              <a href="/#/CustomerDetail?id=6">
                <div class="each-block">
                  <p class="intro">从传统超市到连锁创新，80后超市创二代的生意经！</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="part6">
        <p class="title">媒体报道</p>
        <div class="news-block">
          <a href="/#/NewsDetail?id=1">
            <p class="news-title">及时雨小贷半年度工作总结</p>
            <p class="news-content">7月31日，及时雨高管团队20余人，齐聚新疆乌鲁木齐，召开半年度工作会议。</p>
          </a>
        </div>
        <div class="news-block">
          <a href="/#/NewsDetail?id=9">
            <p class="news-title">及时雨小贷创始人宋梅受邀出席第七届“在沪女企业家峰会”！</p>
            <p class="news-content">3月31日，“巾帼荣耀，星闪浦江——第七届十八省在沪商会女企业家峰会”成功举行。</p>
          </a>
        </div>
        <div class="news-block">
          <a href="/#/NewsDetail?id=10">
            <p class="news-title">全员齐动，稳中求进——2019及时雨小贷团建</p>
            <p class="news-content">2019年10月26日，及时雨小贷团队建设活动！</p>
          </a>
        </div>
        <div class="news-block">
          <a href="/#/NewsDetail?id=8">
            <p class="news-title">及时雨小贷宋梅荣获“2015中国小微金融年度人物”称号</p>
            <p class="news-content">2016年4月9日， 第六届中国小微金融机构联席会年会在北京召开。及时雨小贷宋梅荣获“2015中国小微金融年度人物”荣誉称号。</p>
          </a>
        </div>
        <div class="news-block">
          <a href="/#/NewsDetail?id=2">
            <p class="news-title">周年庆丨六年风雨同行 共谱美好篇章</p>
            <p class="news-content">2013年的3月8日，及时雨小额贷款股份有限公司正式经上海市政府批准成立。</p>
          </a>
        </div>
        <div class="news-block">
          <a href="/#/NewsDetail?id=3">
            <p class="news-title">喜报！上海及时雨小贷斩获“全国优秀小贷”荣誉</p>
            <p class="news-content">未来，及时雨小贷将再接再厉，继续积极发挥优秀典型示范作用！</p>
          </a>
        </div>
        <div class="news-block">
          <a href="/#/NewsDetail?id=5">
            <p class="news-title">重磅：上海小贷行业完成首单同业拆借</p>
            <p class="news-content">2018年4月3日，上海小贷行业首单同业拆借签约仪式在上海嘉定及时雨小额贷款股份有限公司举行。</p>
          </a>
        </div>
      </div>

      <div class="right-banner">
        <div>
          <ul class="list-unstyled text-center">
            <li class="contact-way">
              <a href="/#/notice">
                <span class="words">
                  公司
                  <br />公告
                </span>
              </a>
            </li>
            <li class="weixin-kefu">
              <span class="words">
                快速
                <br />借款
              </span>
              <img src="../img/common/wechat-new.png" alt />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
import Swiper from "swiper";
var swiper;
// document.title='afasdgas';

export default {
  name: "index_wx",
  components: { Header, Footer },
  mounted() {
    let that = this;
    swiper = new Swiper(".swiper-container", {
      paginationClickable: true,
      autoplay: 4000,
      loop: true,
      observer: true,
      observeParents: true,
      onSlideChangeEnd: function(swiper) {
        // console.log(swiper.activeIndex);
      }
    });
  }
};
</script>

<style scoped lang="less">
@import "../../node_modules/swiper/dist/css/swiper.css";
p {
  margin: 0;
}
@white: #fff;
@blue: #3ca0dc;
@gray-lighter: #eee;
@font-rate: 28px;
@gray-dark: #999;
@font-icon-title: 40px;
@gray-light: #dddddd;
@gray-darker: #666;

@media screen and (max-width: 768px) {
  .wrapper {
    padding-top: 90px;
  }
}

.part1 {
  color: #fff;
  height: 478px;
  padding-top: 113px;
  background: url("../img/index/banner-min.png") no-repeat;

  .title {
    font-size: 72px;
    padding-left: 67px;
  }
  .subtitle {
    font-size: 56px;
    padding-left: 67px;
  }
}

.part2 {
  /*height:1017px;*/
  padding: 56px 75px 0;

  .title {
    font-size: 48px;
    color: #35383d;
    margin-bottom: 32px;
  }
  .cont {
    font-size: 28px;
    color: #5e6268;
    margin-bottom: 12px;
    text-align: left;
    line-height: 44px;
  }
  .look-more {
    width: 403px;
    height: 80px;
    line-height: 80px;
    background: #008b7d;
    margin: 48px auto 90px;
    color: #fff;
    font-size: 28px;
  }
  .info {
    margin-left: 50px;
  }
  .info-block {
    margin-bottom: 77px;
    text-align: left;
    .num {
      font-size: 56px;
    }
    .unit {
      font-size: 40px;
    }
    .num-desc {
      font-size: 32px;
    }
    .desc {
      font-size: 26px;
    }
  }
}

.part3 {
  color: #fff;
  height: 738px;
  background: url("../img/index/our-service.png") no-repeat -1537px center;
  background-size: cover;
  /*background:#008B7D;*/
  padding-top: 88px;
  padding-left: 76px;
  text-align: left;

  .title {
    font-size: 48px;
  }
  .service-block {
    margin: 61px 0;

    .subtitle {
      font-size: 40px;
      margin-bottom: 10px;
    }
    .desc {
      font-size: 28px;
      color: rgba(255, 255, 255, 0.8);
      padding-right: 50px;
    }
  }
}

.part4 {
  padding: 80px 20px 0;
  .row {
    margin-bottom: 88px;
  }
  .title {
    font-size: 48px;
    margin-bottom: 60px;
    font-weight: bold;
  }
  .left-block {
    line-height: 162px;
  }
  .right-block {
    padding-left: 47px;

    .subtitle {
      font-size: 40px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    .desc {
      font-size: 28px;
    }
  }
}

.part5 {
  color: #fff;
  height: 800px;
  position: relative;
  .swiper-container,
  .swiper-wrapper,
  .swiper-slide {
    height: 800px;
  }
  .tach-content {
    position: absolute;
    top: 139px;
    left: 94px;
    z-index: 9999;
    .title {
      font-size: 48px;
    }
    .subtitle {
      font-size: 22px;
      opacity: 0.8;
    }
    .green-block {
      width: 41px;
      height: 8px;
      background: rgba(1, 164, 148, 1);
      margin-top: 190px;
      margin-bottom: 60px;
    }
  }
  .swiper-slide {
    background-size: 100% !important;
  }
  .slide-1 {
    background: url("../img/index/story/b1.png") no-repeat center center;
  }
  .slide-2 {
    background: url("../img/index/story/b2.png") no-repeat center center;
  }
  .slide-3 {
    background: url("../img/index/story/b3.png") no-repeat center center;
  }
  .slide-4 {
    background: url("../img/index/story/b4.png") no-repeat center center;
  }

  .each-block {
    padding-left: 95px;
    padding-top: 139px;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      270deg,
      rgba(101, 105, 112, 0) 0%,
      rgba(53, 56, 61, 1) 100%
    );
    .intro {
      font-size: 28px;
      width: 380px;
      line-height: 46px;
      position: absolute;
      top: 490px;
    }
    .title,
    .subtitle,
    .intro {
      color: #fff !important;
    }
  }
  a {
    text-decoration: none;
  }
  a:visited {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
  a:active {
    text-decoration: none;
  }
}

.part6 {
  padding-top: 80px;
  .title {
    font-size: 48px;
    font-weight: 800;
  }
  .news-block {
    padding: 47px 60px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    .news-title {
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: bold;
      color: #2c3e50;
    }
    .news-content {
      font-size: 28px;
      color: #595f67;
    }
  }
  a {
    text-decoration: none;
  }
  a:visited {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
  a:active {
    text-decoration: none;
  }
}

.right-banner {
  width: 80px;
  min-height: 100px;
  position: fixed;
  bottom: 550px;
  right: 15px;
  z-index: 99;
  .right-icon {
    width: 45px;
    height: 45px;
  }
  li {
    width: 100%;
    height: 80px;
    background: #01a494;
    border: 1px solid @gray-lighter;
    border-top: 0;
    cursor: pointer;
    position: relative;
    display: table;
    a {
      width: 100%;
      height: 100%;
      display: table;
    }

    &:hover {
      /*<!--background-color: @blue;-->*/
      .icon-font {
        display: none;
      }
      .words {
        display: block;
      }
      img {
        display: block;
      }
    }
    &.fanhui-li {
      border-top: 1px solid @gray-lighter;
      border-bottom: 0;
    }
    &.contact-way {
      border-top: 1px solid @gray-lighter;
    }
    .icon-font {
      font-size: @font-rate;
      margin-top: 8px;
      color: @gray-dark;
    }
    .words {
      color: #fff;
      /*line-height: 1.2;*/
      padding-top: 12px;
      font-size: 28px;
      align-items: center;
      display: table-cell;

      &.top {
        padding-top: 0;
        line-height: 45px;
      }
    }
    img {
      width: 180px;
      position: absolute;
      right: 79px;
      top: 0;
      display: none;
    }
    &.fanhui-li {
      display: none;
      .icon-font {
        font-size: @font-icon-title;
        margin-top: 2px;
      }
    }
    &.contact-way {
      .contact-info {
        display: none;
        width: 155px;
        position: absolute;
        top: 0;
        right: 45px;
        padding: 15px;
        *padding: 12px;
        background-color: @white;
        border: 1px solid @gray-light;
        p {
          color: @gray-dark;
        }
        h4 {
          color: @gray-darker;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index_wx.vue